export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref12588.6683298e.jpg";